import { render, staticRenderFns } from "./ChangWuLiShiMingDan.vue?vue&type=template&id=063d5a10&scoped=true&"
import script from "./ChangWuLiShiMingDan.vue?vue&type=script&lang=js&"
export * from "./ChangWuLiShiMingDan.vue?vue&type=script&lang=js&"
import style0 from "./ChangWuLiShiMingDan.vue?vue&type=style&index=0&id=063d5a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d5a10",
  null
  
)

export default component.exports